import styled from 'styled-components';
import { font } from '../styles/fonts';

export default styled.h1`
  ${font({ size: 20, weight: 700, lineHeight: 41 })}
`;
